export const BASKET_CHANGED = 'Basket changed';
